module.exports = __webpack_public_path__ + "static/media/concierge.796a0150.png";